const axios = require('axios');

const api = axios.create({
  // baseURL: 'https://via-dev-api-authorize-westeurope.azurewebsites.net/Authorize/'//'https://developapi.via.nl/' + 'auth/'
  baseURL: (window.baseDomain === '' ? '/' : 'https://api.' + window.baseDomain + '/') + 'authorize/',
  withCredentials: true
})

const service = {
  login: function (resolve, username, password) {
    let data = {
      "GrantType": "password",
      "Username": username,
      "Password": password
    }
    api({
        method: 'post',
        url: 'Users/Authorize',
        data: data
      })
      .then(function (response) {
        // handle success
        resolve(response);
      })
      .catch(function (error) {
        // handle error
        resolve(error);
      })
  },
  logout: function (resolve) {
    let data = {
      "GrantType": "log_out"
    }
    api({
        method: 'post',
        url: 'Users/LogOut',
        data: data
      })
      .then(function (response) {
        // handle success
        resolve(response);
      })
      .catch(function (error) {
        // handle error
        resolve(error);
      })
  },
  reset: function(resolve, email){
    let data = {
      "emailaddress": email,
      "callbackUrl": "string"
    }
    api({
      method: 'post',
      url: 'Users/ForgotPassword',
      data: data
    })
    .then(function (response) {
      // handle success
      resolve(response);
    })
    .catch(function (error) {
      // handle error
      resolve(error);
    })
  },
  refreshToken: function (resolve, refreshToken) {
    let data = {
      "GrantType": "refresh_token",
      "RefreshToken": refreshToken
    }

    api({
        method: 'post',
        url: 'Users/RefreshToken',
        data: data
      })
      .then(function (response) {
        // handle success
        resolve(response);
      })
      .catch(function (error) {
        // handle error
        resolve(error);
      })
  },
  getMe: function (resolve, data) {

    api({
        method: 'get',
        url: 'Users/Me?force=true',
        headers: {'Authorization': 'Bearer ' + data.Token}
      })
      .then(function (response) {
        // handle success
        resolve([response, data]);
      })
      .catch(function (error) {
        // handle error
        resolve(error);
      })
  }
}

module.exports = service